import { ReactNode, useState } from 'react'
import styled from 'styled-components'
import { useResetPasswordMutation } from '@/api/user-api'
import { ResetPasswordFormValues } from '@/components/form/reset-password-form'
import { LoginLayout } from '@/components/layout/entry-layout'
import ResetPasswordSuccessView from '@/components/reset-password/reset-password-success-view'
import ResetPasswordView from '@/components/reset-password/reset-password-view'
import { NextLayoutComponentType } from '@/types/next-layout-component-type'
import { ampli } from '@/utils/ampli'
import logger from '@/utils/logger'

const ResetPassword: NextLayoutComponentType = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false)

  const [resetPassword] = useResetPasswordMutation()

  const handleFinish = async (
    values: ResetPasswordFormValues,
  ): Promise<void> => {
    const { email } = values
    ampli.submitForgetPassword({ emails: [email] })

    try {
      await resetPassword(email).unwrap()
      setIsSuccess(true)
    } catch (error) {
      logger.error(error)
      ampli.submitForgetPasswordFailed({ emails: [email] })
    }
  }

  return (
    <Container>
      {isSuccess ? (
        <ResetPasswordSuccessView />
      ) : (
        <ResetPasswordView onFinish={handleFinish} />
      )}
    </Container>
  )
}

ResetPassword.getLayout = (page): ReactNode => <LoginLayout>{page}</LoginLayout>

export default ResetPassword

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: fit-content;
`
